import { MatTableGroupDataSource } from "src/app/services/group-by/table-data.service";
import { CommonFile } from "../file";
import { EmptyKeyValue, KeyValue } from "../key-value";
import { Vehicle } from "../vehicles/vehicle";
import { Document } from "../documents/document";


export class Report {
  id: number;
  adminFileId: number;
  adminFile?: string;
  entity?: string;
  tracking: string;
  isSent: boolean;
  sentDate?: Date;
  createdAt: Date;
  documents?: Array<Document>;
  vehicles?: Array<Vehicle>;
  client: Array<any>;
  broker: Array<any>;
  user: string;
  
  constructor(item) {
    this.id = item.id;
    this.adminFileId = item.adminFileId;
    this.adminFile = item.adminFile;
    this.entity = item.entity;
    this.tracking = item.tracking;
    this.isSent = item.isSent;
    this.sentDate = item.sentDate;
    this.createdAt = item.createdAt;
    this.documents = item.documents;
    this.vehicles = item.vehicles;
    this.client = item.client;
    this.broker = item.brokers;
    this.user = item.user;
  }

}
